<script setup lang="ts">
import SimpleLayout from '#components/layouts/SimpleLayout.vue';
import { useLanguage } from '#composables/useLanguage';
import VueFeather from 'vue-feather';

const { t } = useLanguage();

const props = withDefaults(
  defineProps<{
    titleKey?: string;
    subtitleKey?: string;
    icon?: string;
  }>(),
  {
    titleKey: 'commonLabel.errorData',
    subtitleKey: 'commonLabel.errorMessage',
    icon: 'alert-triangle'
  }
);
</script>

<template>
  <SimpleLayout :title="t(props.titleKey)">
    <div class="flex flex-col items-center justify-center h-[calc(100vh-140px)] px-4">
      <div
        class="border border-persistent-border-main-primary rounded-3xl p-12 flex flex-col items-center w-full md:w-[600px] lg:w-[700px] bg-white shadow-sm -mt-20"
      >
        <!-- Image / Icon on top -->
        <div class="flex justify-center items-center w-32 h-32 bg-gray-100 rounded-full mb-8">
          <VueFeather :type="props.icon" :size="68" class="opacity-50 text-gray-500" />
        </div>

        <!-- Title -->
        <h1 class="mb-4 text-xl font-bold text-center text-gray-900">
          {{ t(props.titleKey) }}
        </h1>

        <!-- Content -->
        <p class="whitespace-pre-line text-sm text-center text-gray-600 max-w-lg">
          {{ t(props.subtitleKey) }}
        </p>
      </div>
    </div>
  </SimpleLayout>
</template>
